import { agentApiFetch } from "@/lib/agentApiFetch";

export async function fetchTicketEmailConfig({ workspaceId }) {
  return agentApiFetch("/api/v1/agent/ticket-email/config", { workspaceId });
}

export async function updateTicketEmailConnection({ workspaceId, payload }) {
  const body = { ...payload };
  if (!body.clientSecret) delete body.clientSecret;
  if (!body.clientToken) delete body.clientToken;
  if (!body.webhookSigningSecret) delete body.webhookSigningSecret;
  return agentApiFetch("/api/v1/agent/ticket-email/config", {
    method: "PUT",
    workspaceId,
    body,
  });
}

export async function updateTicketEmailAutomations({ workspaceId, automations }) {
  return agentApiFetch("/api/v1/agent/ticket-email/automations", {
    method: "PUT",
    workspaceId,
    body: { automations },
  });
}

export async function updateTicketEmailTemplates({ workspaceId, templates }) {
  return agentApiFetch("/api/v1/agent/ticket-email/templates", {
    method: "PUT",
    workspaceId,
    body: { templates },
  });
}

export async function testTicketEmailConnectivity({ workspaceId, payload } = {}) {
  const body = payload ? { ...payload } : undefined;
  if (body) {
    if (!body.clientSecret) delete body.clientSecret;
    if (!body.clientToken) delete body.clientToken;
    if (!body.webhookSigningSecret) delete body.webhookSigningSecret;
  }
  return agentApiFetch("/api/v1/agent/ticket-email/test-connectivity", {
    method: "POST",
    workspaceId,
    body,
  });
}

export async function pollTicketEmailInbox({ workspaceId, maxMessages = 20 }) {
  const path = `/api/v1/agent/tickets/poll-imap?max_messages=${encodeURIComponent(maxMessages)}`;
  return agentApiFetch(path, {
    method: "POST",
    workspaceId,
  });
}

export async function fetchTicketEmailSenders({ workspaceId }) {
  return agentApiFetch("/api/v1/agent/ticket-email/senders", { workspaceId });
}

export async function runConversationDigest({ workspaceId, to }) {
  return agentApiFetch("/api/v1/agent/ticket-email/automations/conversationDigest/run", {
    method: "POST",
    workspaceId,
    body: { to },
  });
}

export function webhookUrlForProvider(provider, workspaceId, tenantId) {
  const base = `${window.location.origin}/api/v1/agent/webhooks/email/${encodeURIComponent(provider)}`;
  const params = new URLSearchParams();
  if (workspaceId) params.set("workspace_id", workspaceId);
  if (tenantId) params.set("tenant_id", String(tenantId));
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
